// Replace products on section history when use select a new date

let diagsJson = document.getElementById('results-history-json');
let jsonData = JSON.parse(diagsJson.textContent); // Get the content into diagsJson and parse it to JSON

let productsHistoryContainer = document.querySelector('.diag-history__products-container');
let selectOptions = document.querySelector('.diag-history__select');
selectOptions?.addEventListener('change', function (event) {
  let selectedValue = event.target.value;
  updateProductsHistory(selectedValue);

  //Update text "diag is for someone else"
  let diagForSomeoneElseText = document.querySelector('.diag-history__for-someone-else');
  let diagIsForWho = jsonData[selectedValue].this_is_for;
  if (diagIsForWho == "me") {
    diagForSomeoneElseText.style.display = "none";
  } else if (diagIsForWho == "someone_else") {
    let nameToReplace = document.querySelector('.diag-history__for-someone-else-name');
    let newName = jsonData[selectedValue].name;
    nameToReplace.innerHTML = newName;
    diagForSomeoneElseText.style.display = "block";
  }

  // Update routine infos on the atc button
  let atcButton = document.querySelector('.diag-history .diag-result__add-routine-to-cart');
  let newProducts = document.querySelector('.diag-history__products');
  let newPrice = newProducts.getAttribute('data-products-price');
  let newIds = newProducts.getAttribute('data-products-ids');
  atcButton.querySelector('.button-price').innerHTML = newPrice;
  atcButton.setAttribute('data-products-ids', newIds);
});

// Handle diagnostic result deletion
document.querySelector('[data-diag-result-delete]').addEventListener('click', async event => {
  let metaobjectId = parseInt(event.target.getAttribute('data-diag-result-delete'));
  if (!metaobjectId) {
    throw new Error('No metaobject id found during deletion');
  }
  let result = await window.sendDiagData('delete', {
    metaobject_id: metaobjectId
  });
  if (result.ok) {
    window.location.reload();
    let url = new URL(window.location.href);
    url.searchParams.set('deleted-diag', 'true');
    window.location.href = url.toString();
  } else {
    throw new Error('Error while deleting the diagnostic result');
  }
});

// Handle diagnostic result edit
document.querySelector('[data-diag-result-edit]').addEventListener('click', event => {
  let metaobjectId = event.target.getAttribute('data-diag-result-edit');
  let diagLink = event.target.getAttribute('data-diag-link');
  let diagData = JSON.parse(document.getElementById('last-diag-data').textContent);
  if (!metaobjectId || !diagData || !diagLink) {
    throw new Error('Metaobject id, diag data or diag link not found during edit');
  }
  localStorage.setItem('diagnostic-edit-data', JSON.stringify(diagData));
  window.location.href = `${diagLink}?edit=${metaobjectId}`;
});

// Display a message if the diagnostic result has been deleted
document.addEventListener('DOMContentLoaded', () => {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('deleted-diag')) {
    document.querySelector('.all-customer-diags__delete-message').style.display = 'block';

    // Remove the 'deleted-diag' parameter from the URL
    let url = new URL(window.location.href);
    url.searchParams.delete('deleted-diag');
    window.history.replaceState({}, document.title, url.toString());
  }
});

// FUNCTIONS

function updateProductsHistory(selectedDiag) {
  let selectedData = jsonData[selectedDiag]; // Get the data for the selected date
  if (selectedData) {
    productsHistoryContainer.innerHTML = selectedData.html;
    //atcButtons = document.querySelectorAll('.diag-result__add-routine-to-cart');
  } else {
    console.error("No data found for the selected date: ", selectedDiag);
  }
}